(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui/step-indicator-balls/react/step-indicator-balls.js') >= 0) return;  svs.modules.push('/components/tb-ui/step-indicator-balls/react/step-indicator-balls.js');

'use strict';

const _svs$ui$ReactStepIndi = svs.ui.ReactStepIndicator,
  StepIndicator = _svs$ui$ReactStepIndi.StepIndicator,
  Step = _svs$ui$ReactStepIndi.Step;

const StepIndicatorStepLabelWrapper = _ref => {
  let useAnimation = _ref.useAnimation,
    onSelectedStep = _ref.onSelectedStep,
    children = _ref.children;
  const enhanchedChildren = React.Children.map(children, (child, index) => {
    if (index === 0 && React.isValidElement(child)) {
      return React.cloneElement(child, {
        onSelected: onSelectedStep,
        useAnimation
      });
    }
    return child;
  });
  return React.createElement("div", {
    className: "step-indicator-step-label-wrapper"
  }, enhanchedChildren);
};
const StepIndicatorLineContainer = _ref2 => {
  let children = _ref2.children;
  return React.createElement("div", {
    className: "step-indicator-line-container"
  }, children);
};

const StepIndicatorBalls = _ref3 => {
  let _ref3$isActiveHidden = _ref3.isActiveHidden,
    isActiveHidden = _ref3$isActiveHidden === void 0 ? false : _ref3$isActiveHidden,
    _ref3$isLabelsHidden = _ref3.isLabelsHidden,
    isLabelsHidden = _ref3$isLabelsHidden === void 0 ? false : _ref3$isLabelsHidden,
    _ref3$isShowDottedLin = _ref3.isShowDottedLines,
    isShowDottedLines = _ref3$isShowDottedLin === void 0 ? false : _ref3$isShowDottedLin,
    _ref3$isTwoStepVarian = _ref3.isTwoStepVariant,
    isTwoStepVariant = _ref3$isTwoStepVarian === void 0 ? false : _ref3$isTwoStepVarian,
    _ref3$step = _ref3.step,
    step = _ref3$step === void 0 ? 1 : _ref3$step;
  if (isNaN(step) || step < 1 || step > 3) {
    step = 1;
  }
  return React.createElement(StepIndicator, {
    block: true,
    branding: "step-indicator-balls",
    className: (isTwoStepVariant ? "js-step-indicator-balls two-step-indicator-".concat(step) : 'js-step-indicator-balls') + (isLabelsHidden ? ' hasNoLabels' : ''),
    showDone: true
  }, React.createElement(StepIndicatorStepLabelWrapper, null, React.createElement(Step, {
    isDone: step > 1,
    isSelected: step === 1 && !isActiveHidden,
    name: "one"
  }, "1"), !isLabelsHidden && React.createElement("div", {
    className: "step-indicator-balls-label"
  }, isTwoStepVariant ? 'Gränser' : 'Registrera')), React.createElement(StepIndicatorLineContainer, null, isShowDottedLines && React.createElement("div", {
    className: "step-indicator-line"
  })), React.createElement(StepIndicatorStepLabelWrapper, null, React.createElement(Step, {
    isDone: step > 2,
    isSelected: step === 2 && !isActiveHidden,
    name: "two"
  }, "2"), !isLabelsHidden && React.createElement("div", {
    className: "step-indicator-balls-label"
  }, isTwoStepVariant ? 'Insättning' : 'Gränser')), !isTwoStepVariant ? React.createElement(StepIndicatorLineContainer, null, isShowDottedLines && React.createElement("div", {
    className: "step-indicator-line"
  })) :
  React.createElement(React.Fragment, null), !isTwoStepVariant ? React.createElement(StepIndicatorStepLabelWrapper, null, React.createElement(Step, {
    isSelected: step === 3 && !isActiveHidden,
    name: "three"
  }, "3"), !isLabelsHidden && React.createElement("div", {
    className: "step-indicator-balls-label"
  }, "Ins\xE4ttning")) :
  React.createElement(React.Fragment, null));
};
svs.components.tb_ui.stepIndicatorBalls.StepIndicatorBalls = StepIndicatorBalls;

 })(window);